function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVypocetKubatury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.32 89.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.16,86.89l14.47-36.33c.57-1.42,2.36-1.87,3.52-.88l5.53,4.68c1.14.96,2.88.57,3.49-.79L50.54,1.32c.79-1.77,3.3-1.77,4.09,0l26.52,59.32c.6,1.35,2.33,1.75,3.47.81l1.83-1.51c1.22-1.01,3.08-.46,3.56,1.05l8.26,26.04c.46,1.44-.62,2.91-2.13,2.91H2.24c-1.58,0-2.66-1.6-2.08-3.07Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.12,86.89l14.47-36.33c.57-1.42,2.36-1.87,3.52-.88l5.53,4.68c1.14.96,2.88.57,3.49-.79L194.5,1.32c.79-1.77,3.3-1.77,4.09,0l26.52,59.32c.6,1.35,2.33,1.75,3.47.81l1.83-1.51c1.22-1.01,3.08-.46,3.56,1.05l8.26,26.04c.46,1.44-.62,2.91-2.13,2.91h-93.89c-1.58,0-2.66-1.6-2.08-3.07Z",
    style: {
      fill: "#051f1f",
      opacity: 0.2,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.12,86.89l11.2-15.91c2.87-4.28,5.5-3.37,6.67-2.38l4.51,2.93c.85.72,2.05.68,2.85.04.93-.75,1.83-1.54,2.86-2.14l6.33-3.74c12.98-6.13,24.82-14.26,33.17-.81,1.98,3.18,4.5,5.98,7.39,8.36,3.49,2.87,6.72,6.32,8.32,5.4l1.83-1.51c1.05-.86,2.35-.41,3.27.46,1.6,1.52,9.69,9.46,9.69,9.46.46,1.44-.62,2.91-2.13,2.91h-93.89c-1.58,0-2.66-1.6-2.08-3.07Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.2 45.97 129.12 30.05 113.2 14.14 113.2 45.97",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVypocetKubatury);
export default __webpack_public_path__ + "static/media/vypocet-kubatury.35e13d1352cf58c087b82ad1f0990d14.svg";
export { ForwardRef as ReactComponent };